// extracted by mini-css-extract-plugin
export default {"otpContainer":"otp-input__otpContainer___WZgu-","otpInputs":"otp-input__otpInputs___kYkDf","otpInput":"otp-input__otpInput___fjK2X","otpSeparator":"otp-input__otpSeparator___0VOSN"};